<script>
import { Line } from "vue-chartjs";
import zoom from 'chartjs-plugin-zoom';

export default {
  extends: Line,
  props: [
    'labels',
    'datasets',
    'unit'
  ],
  data: () => ({
    unit1: null,
    unit2: null
  }),
  methods:{
  },
  mounted() {
    this.addPlugin(zoom);
    if(this.unit[1]){
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.datasets,
          unit: this.unit,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          
          pan: {
                mode: "xy",
                speed: 1,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'x',
                drag: false,
                speed: 1,
            },
          legend: {
            position: "bottom"
          },
          scales: {
                xAxes: [ {
                    display: true,
                    scaleLabel: {
                          display: true,
                          labelString: 'Date'
                        },
                ticks: {
                    major: {
                      fontStyle: 'bold',
                      fontColor: '#FF0000'
                  }
                }
                } ],
                yAxes: [{
                      id: 'A',
                      type: 'linear',
                      position: 'left',
                      display: true,
                      scaleLabel: {
                          display: true,
                          labelString: this.unit[0]
                        },
                  }, 
                {
                      id: 'B',
                      type: 'linear',
                      position: 'right',
                      scaleLabel: {
                          display: true,
                          labelString: this.unit[1]
                        },
                  
              }],
            
              
          },
          legend:{
            display: true,
        //     onClick: function(event, legendItem) {
        //          var index = legendItem.datasetIndex;
        //     //toggle chosen dataset's visibility
        //     Line.data.datasets[index].hidden = 
        //         !Line.data.datasets[index].hidden;
        //     //toggle the related labels' visibility
        //     Line.options.scales.yAxes[index].display =                 
        //         !Line.options.scales.yAxes[index].display;
        //     Line.update();
        // },
            
            labels: {
              
              usePointStyle: true,
              boxWidth: 5,
              
              
            } 
        }

        }
        
      );
    }else{
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.datasets,
          unit: this.unit,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          pan: {
                mode: "xy",
                speed: 1,
                threshold: 10
            },
            zoom: {
                enabled: true,
                mode: 'x',
                drag: false,
                speed: 1,
            },
          legend: {
            position: "bottom"
          },
          scales: {
                xAxes: [ {
                    display: true,
                    scaleLabel: {
                          display: true,
                          labelString: 'Date'
                        },
                ticks: {
                    major: {
                      fontStyle: 'bold',
                      fontColor: '#FF0000'
                  }
                }
                } ],
                yAxes: [{
                      id: 'A',
                      type: 'linear',
                      position: 'left',
                      display: true,
                      scaleLabel: {
                          display: true,
                          labelString: this.unit[0]
                        },
                  }],
          },
          legend:{
            display: true,
            labels: {
              usePointStyle: true,
              boxWidth: 5,
            } 
        }
        }
      );
    }
  }
};
</script>
